/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import Pagination from './Pagination'
import Task from './Task'

/**
 * The InlineResponse20028 model module.
 * @module model/InlineResponse20028
 * @version 1.0.0
 */
export default class InlineResponse20028 {
  /**
   * Constructs a new <code>InlineResponse20028</code>.
   * @alias module:model/InlineResponse20028
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20028</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20028} obj Optional instance to populate.
   * @return {module:model/InlineResponse20028} The populated <code>InlineResponse20028</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20028()

      if (data.hasOwnProperty('tasks')) {
        obj['tasks'] = ApiClient.convertToType(data['tasks'], [Task])
      }
      if (data.hasOwnProperty('pagination')) {
        obj['pagination'] = Pagination.constructFromObject(data['pagination'])
      }
    }
    return obj
  }

  /**
   * @member {Array.<module:model/Task>} tasks
   */
  tasks = undefined
  /**
   * @member {module:model/Pagination} pagination
   */
  pagination = undefined
}
